import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    console.log('[AuthGuard] Checking access for route:', state.url);
    console.log('[AuthGuard] User authenticated:', this.authenticated);
    console.log('[AuthGuard] User roles:', this.roles);

    //if User is not logged in force him
    await this.isLoggedIntoKeycloak(state);
    // Get the roles required from the route.
    const requiredRoles = route.data['roles'];
    const allowed = this.isRolePresent(requiredRoles);
    console.log(
      '[AuthGuard] Access allowed for route',
      state.url,
      ':',
      allowed
    );
    return allowed;
  }

  private isRolePresent(requiredRoles: any[]): boolean {
    // Allow the user to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }
    // Allow the user to proceed if all the required roles are present.
    if (requiredRoles.every((role) => this.roles.includes(role))) {
      return true;
    }

    //Allow the user to proceed if any required role is present.
    for (const element of requiredRoles) {
      if (this.roles.includes(element)) {
        return true;
      }
    }

    // redirect to error page if the user doesn't have the necessary role to access
    this.router.navigate(['access-denied']);
    return false;
  }

  private async isLoggedIntoKeycloak(state: RouterStateSnapshot) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      console.warn(
        '[AuthGuard] User not authenticated - redirecting to Keycloak login'
      );
      console.log(
        '[AuthGuard] Redirect URI:',
        window.location.origin + state.url
      );
      try {
        await this.keycloak.login({
          redirectUri: window.location.origin + state.url,
        });
        console.log('[AuthGuard] Login initiated successfully');
      } catch (error) {
        console.error('[AuthGuard] Login failed with error:', error);
        throw error;
      }
    } else {
      console.log('[AuthGuard] User already authenticated, proceeding...');
    }
  }
}
